import http from 'hub-http/clients/apiClient';
import httpHubless from 'hub-http/clients/noPortalApiClient';
const API_BASE = 'userpreferences/v1/profile';
export default class ProfileAPI {
  static getProfile({
    hubless
  }) {
    if (hubless) {
      return httpHubless.get(`${API_BASE}/hubless`);
    }
    return http.get(API_BASE);
  }
  static updateProfile(profile) {
    return httpHubless.put(API_BASE, {
      data: profile
    });
  }
  static updatePassword(data) {
    return httpHubless.post(`${API_BASE}/update-password`, {
      data
    });
  }
  static resetPassword() {
    return httpHubless.post(`${API_BASE}/reset-password`);
  }
  static getIsScimUser() {
    return httpHubless.get(`${API_BASE}/scim`);
  }
}